/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const jiraOauthFailureStateResponseSchema = z.object({
  createdAt: z.iso.datetime().nullish(),
  daysSinceFailure: z.int().nullish(),
  hasFailure: z.boolean(),
});
